<div 
    id="ArmaRepartitionContainer-{{prefixId}}"
    class="div-canvas-input"
    (resized)="onResize()"
    style="position: relative; min-width: 300px; height: 150px;">
    <canvas #armaRepartitionCanvas
        style="height: inherit; width: 100%; position: absolute; left: 0;">
    </canvas>
</div>